import React, { useContext } from 'react';
import { Avatar, Dropdown, Layout, Menu } from 'antd';
import {
  CaretDownFilled,
  LogoutOutlined,
  SwapOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { localizationConstants } from 'constants/index';
import { localizationHelpers, userHelpers } from 'helpers';
import { t } from 'helpers/i18n';
import { StoreContext } from 'contexts';
import { Link } from 'react-router-dom';
import TerraLogo from 'assets/images/v2/terra_logo.png';
import DocumentLogo from 'assets/images/v2/ic_document.svg';
import './AppHeader.scss';
import { Routes } from 'constants/routes';
import OrganizationSelector from './header/OrganizationSelector';
import { useSelector } from 'react-redux';
import { RootState } from 'store/reducer';
import TekoMarket from 'teko-market-v1';
import IcAppSwitcher from 'assets/images/v2/ic_app_switcher.svg';
import { openDocumentation } from 'helpers/documentation';

const { AppSwitcher } = TekoMarket;
const { Header } = Layout;
const { REGIONS } = localizationConstants;
const { getCurrentLanguage } = localizationHelpers;
const { logout } = userHelpers;

interface WelcomeNewOrganizationProps {
  isMarginLeft?: boolean;
  customHeader?: React.ReactElement;
}

const AppHeader: React.FC<WelcomeNewOrganizationProps> = ({
  isMarginLeft,
  customHeader,
}) => {
  const { currentUser } = useContext(StoreContext);
  const visibleOrganizationInfo = useSelector(
    (state: RootState) => state.ui.headerState.visibleOrganizationInfo
  );

  const userMenu = (
    <Menu>
      <Menu.Item data-testid="btn-logout" onClick={logout}>
        <LogoutOutlined />
        <span style={{ marginLeft: '4px' }}>{t('Logout')}</span>
      </Menu.Item>
    </Menu>
  );

  const currentRegion = REGIONS[getCurrentLanguage()];

  return (
    <Header
      className="app-header-v2"
      style={{ width: isMarginLeft ? 'calc(100% - 360px)' : '100%' }}
    >
      <div className="header-row">
        <div className="app-logo">
          <Link to={Routes.v2_projectList}>
            <img src={TerraLogo} alt="logo" />
          </Link>
        </div>

        <div className="header-custom">{customHeader}</div>

        <AppSwitcher
          baseMMUrl={window.REACT_APP_MM_BASE_CORE_URL}
          apiMerchantBffUrl={window.REACT_APP_MM_BASE_BFF_URL}
          customImageUrl={IcAppSwitcher}
        />

        <Link className="app-user" to="/">
          <SwapOutlined id="guide-header-icon" />
          <span className="name">{t('Switch to v1')}</span>
        </Link>

        {visibleOrganizationInfo && (
          <div className="app-user">
            <OrganizationSelector />
          </div>
        )}

        <span className="app-user" onClick={openDocumentation}>
          <img src={DocumentLogo} alt="doc" sizes="24" />
          <span className="name">{t('Go to docs')}</span>
        </span>

        <span className="app-user">
          <Avatar src={currentRegion && currentRegion.flag} size="small" />
          <span className="name">{currentRegion && currentRegion.name}</span>
        </span>

        <Dropdown overlay={userMenu} trigger={['click']}>
          <span className="app-user">
            {currentUser.picture ? (
              <Avatar src={currentUser.picture} />
            ) : (
              <Avatar icon={<UserOutlined />} />
            )}
            <span className="name">{currentUser.name}</span>
            <CaretDownFilled sizes="24" color="#A7ABC3" />
          </span>
        </Dropdown>
      </div>
    </Header>
  );
};

export default AppHeader;
